"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var _default = function _default(a, b, c) {
  var d,
    e = !1,
    f = a.inputName && b && b[a.inputName];
  if (c && c[a.id] ? e = !0 : c && a.inputs && a.inputs.some(function (a) {
    c[a.id] && (e = !0);
  }), "checkbox" === a.type) d = a.choices.filter(function (c) {
    return f ? c.value === b[a.inputName] : c.isSelected;
  }).map(function (a) {
    return a.value;
  }), e && (d = a.inputs.filter(function (a) {
    return c[a.id];
  }).map(function (a) {
    return a.label;
  }));else if ("radio" === a.type) {
    if (f) d = b[a.inputName];else {
      var g = a.choices.find(function (a) {
        return a.isSelected;
      });
      d = g ? g.value : "";
    }
  } else if ("select" === a.type) {
    var h = a.choices.filter(function (c) {
      return f ? c.value === b[a.inputName] : c.isSelected;
    }).map(function (a) {
      return {
        value: a.value,
        label: a.text
      };
    });
    d = h && 0 < h.length ? h[0] : "";
  } else d = f ? b[a.inputName] : e ? c[a.id] : a.defaultValue;
  return d;
};
exports["default"] = _default;